import { PersonOption } from '../../components/person-select/person-select.component';

/** Minimal control surface the helper needs — satisfied by `FormControl<string | null>`. */
export interface PrefillableControl {
  readonly value: string | null;
  readonly dirty: boolean;
  setValue(value: string, options?: { emitEvent?: boolean }): void;
}

/**
 * NEX-824: prefills an owner/assignee/author control with the current user when
 * creating a new entity.
 *
 * Never overwrites a value the user already has (an explicit choice or a value
 * already loaded for editing) — only applies to a control that is both untouched
 * (`!dirty`) and still empty. Only applies when the current user is present in the
 * already-filtered options: PENDING/inactive project memberships are excluded
 * upstream (NEX-822), so their absence here means the field must stay empty and
 * force the user to pick someone explicitly (required validation then blocks save).
 */
export function prefillOwnerWithCurrentUser(
  control: PrefillableControl,
  currentUserId: string,
  options: readonly PersonOption[],
): void {
  if (control.dirty || (control.value ?? '').trim()) return;
  if (!options.some((option) => option.id === currentUserId)) return;
  control.setValue(currentUserId);
}
